import { Box } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import { GridRenderEditCellParams } from '@mui/x-data-grid-pro'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import dayjs, { Dayjs } from 'dayjs'

interface EditDatePickerProps {
  params: GridRenderEditCellParams<any, string | null>
  onChange: (_newValue: Dayjs | null) => void
}

const EditDatePicker: FC<EditDatePickerProps> = ({ params, onChange }) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    setOpen(true)
  }, [])

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          width: '100%',
        }}
      >
        <DatePicker
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          value={params?.value ? dayjs(params?.value) : null}
          onChange={newValue => {
            setOpen(false)
            onChange(newValue)
          }}
          slotProps={{
            textField: {
              variant: 'outlined',
              sx: {
                '& .MuiInputAdornment-root': {
                  display: 'none',
                },
                width: '100%',
                textAlign: 'center',
              },
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  )
}

export default EditDatePicker
